import { supabase } from './supabase';
import { getFeatureInterestCore, upsertFeatureInterestCore } from '@gv/core';

export type FeatureKey = 'desktop_app' | 'ios_app' | 'android_app';

export async function getFeatureInterest(): Promise<{ desktop_app: boolean; ios_app: boolean; android_app: boolean }> {
    const user = (await supabase.auth.getUser()).data.user;
    if (!user) throw new Error('Not signed in');
    return await getFeatureInterestCore(supabase as any, user.id);
}

export async function upsertFeatureInterest(feature: FeatureKey, interested: boolean) {
    const user = (await supabase.auth.getUser()).data.user;
    if (!user) throw new Error('Not signed in');
    await upsertFeatureInterestCore(supabase as any, user.id, feature as any, interested);
}
